import script from "./Artwork.vue?vue&type=script&setup=true&lang=js"
export * from "./Artwork.vue?vue&type=script&setup=true&lang=js"

import "./Artwork.vue?vue&type=style&index=0&id=4879c658&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\artware\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4879c658"]])

export default __exports__